import { DefaultLayout } from '@c/layouts';
import PrivacyPolicyPage from '@c/PrivacyPolicyPage';
import SEO from '@c/SEO';
import React from 'react';

const PrivacyPolicy = () => {
  return (
    <>
      <SEO
        title="Privacy Policy"
        description="GearFocus privacy policy explains how we collect, use, and protect your personal information on our camera gear marketplace."
      />
      <PrivacyPolicyPage />
    </>
  );
};

PrivacyPolicy.getLayout = function getLayout(page: React.ReactElement) {
  return <DefaultLayout>{page}</DefaultLayout>;
};

export default PrivacyPolicy;
